// general type definitions crossing over multiple models
export type Image = {
  url: string
  id: number
  boxFileId?: string
  boxAccessToken?: string
}

const privacyMap = {
  company: 2,
  global: 3,
  mine: 4
}

export type Privacy = typeof privacyMap[keyof typeof privacyMap]

type PrivacyKeys = keyof typeof privacyMap

export const privacyValue = (key: PrivacyKeys): Privacy => {
  return privacyMap[key]
}
